import { isNumericId } from '../utils/safe-url.js';

export function initVimeoModal() {
  const modal = document.getElementById('videoModal');
  const iframe = document.getElementById('modalIframe');
  const closeBtn = document.getElementById('modalClose');
  if (!modal || !iframe || !closeBtn) return;

  function open(vimeoId) {
    if (!isNumericId(vimeoId)) return;
    iframe.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    iframe.src = '';
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.video-card').forEach((card) => {
    card.addEventListener('click', () => {
      open(card.getAttribute('data-vimeo'));
    });
  });

  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('open')) close();
  });
}
